import Link from "next/link";
import React from "react";
import Twitter from "../../../assets/svg/followMaticSvgs/Twitter";
import Instagram from "../../../assets/svg/followMaticSvgs/Instagram";
import LinkedIn from "../../../assets/svg/followMaticSvgs/LinkedIn";
import Youtube from "../../../assets/svg/followMaticSvgs/Youtube";

export default function SubscribeSectionSocial() {
  return (
    <ul className="flex gap-[16px] lg:gap-[24px] mt-[30px]">
      <li>
        <Link
          href="https://twitter.com/maticrobots"
          title="Matic - Twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Twitter customClasses={"group"} />
        </Link>
      </li>
      <li>
        <Link
          href="https://www.instagram.com/maticrobots/"
          title="Matic - Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram customClasses={"group"} />
        </Link>
      </li>
      <li>
        <Link
          href="https://www.linkedin.com/company/matician"
          title="Matic - LinkedIn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedIn customClasses={"group"} />
        </Link>
      </li>
      <li>
        <Link
          href="https://www.youtube.com/@maticrobots"
          title="Matic - Youtube"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Youtube customClasses={"group"} />
        </Link>
      </li>
    </ul>
  );
}
